module.exports = __webpack_public_path__ + "static/media/pycs_03.cc9d9ee5.gif";